import React from 'react';
import { Tabs } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { useNavigate, useLocation } from 'react-router-dom';
import { PATH } from 'constants/path';
import { getUrlParam } from 'utils/common';

import SettingIcon from 'assets/setting/Link.svg';
import SettingArrow from 'assets/setting/Chevron right.svg';
import AviabilityPage from './components/AviabilityPage';
import RemindersPage from './components/RemindersPage';
import CalendarCustomizationPage from './components/CalendarCustomizePage';
import VideoVisitPage from './components/VideoVisitPage';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { EFeatureType } from 'types/provider';

const Page = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [homeInfo] = useProviderHomeInfo();
    const hasKlarityMeeting = true;

    // 从 URL 参数获取要激活的 tab，如果没有则默认为 '1'
    const tabFromUrl = getUrlParam('tab');
    const defaultActiveKey = tabFromUrl && ['1', '2', '3', '4'].includes(tabFromUrl) ? tabFromUrl : '1';
    const [activeKey, setActiveKey] = React.useState(defaultActiveKey);

    // 当 URL 参数变化时，更新 activeKey
    React.useEffect(() => {
        const tabFromUrl = getUrlParam('tab');
        if (tabFromUrl && ['1', '2', '3', '4'].includes(tabFromUrl)) {
            setActiveKey(tabFromUrl);
        }
    }, [location.search]);

    const tabItems = React.useMemo(() => {
        const items = [
            {
                label: 'Availability',
                key: '1',
                children: <AviabilityPage />,
            },
            ...(hasKlarityMeeting
                ? [
                    {
                        label: 'Video visit',
                        key: '2',
                        children: <VideoVisitPage />,
                    },
                ]
                : []),
            {
                label: 'Reminders',
                key: '3',
                children: <RemindersPage />,
            },
            {
                label: 'Calendar customization',
                key: '4',
                children: <CalendarCustomizationPage />,
            },
        ];
        return items;
    }, [hasKlarityMeeting]);

    const handleTabChange = (key: string) => {
        setActiveKey(key);
        // 更新 URL 参数
        const url = new URL(window.location.href);
        url.searchParams.set('tab', key);
        navigate(`${url.pathname}${url.search}`, { replace: true });
    };

    return (
        <div className={`${s.wrap} px-6 py-12`}>
            <div className={s.nav}>
                <div className="flex">
                    <img className="w-5 h-5" style={{ marginRight: '10px' }} src={SettingIcon} />
                    <div className="text-gray-500 font-medium text-sm cursor-pointer" onClick={() => navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR}`)}>Calendar</div>
                </div>
                <img className={s.arrow} src={SettingArrow} alt="" />
                <div className="font-medium" style={{ color: '#00816B' }}>Settings</div>
            </div>
            <Tabs
                activeKey={activeKey}
                items={tabItems}
                onChange={handleTabChange}
            />
            <div className={commonS.chatWrap}>
                <AIChat
                    pageId={EAIChatPageId.PROVIDER_CALENDAR_SETTING}
                    defaultShow={false}
                    makeFix={false}
                />
            </div>
        </div>
    );
};

export default Page;
